import React, { useEffect, useState } from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Select, TextInput } from "../components/form/inputs";
import CalendarInput from "../components/form/CalendarInput";
import Checkbox from "../components/form/inputs/Checkbox";
import { GoSun, GoMoon } from "react-icons/go";
import InputBase from "../components/form/inputs/InputBase";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { useDispatch, useSelector } from "react-redux";
import OrderdetailShimmer from "../components/Preloader/OrderdetailShimmer";
import {
  addOrupdateCustomerOrder,
  getAllMealOnOrder,
  verifyOrderStartDate,
  getCustomerDataDeliverAnOrder,
  getCustomerDetail,
} from "../redux/thunks/orderCustomerThunk";
import toast from "react-hot-toast";
import { getCustomerAddressById } from "../redux/thunks/customerAddThunk";
import RadioCardGroup from "../components/button/RadioCardGroup";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId } from "../utils/urlCrypto";

const Orderedit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isOrderLoading } = useSelector((state) => state.customerOrder);
  const { addressId } = useSelector((state) => state.customerAddress);
  const [defaultAdd, setDefaultAdd] = useState();
  const { orderId } = useParams();
  const order_id = decryptId(orderId);
  const [customerData, setCustomerData] = useState({});
  const [orderAmount, setOrderAmount] = useState("");
  const [date, setDate] = useState("");
  const [selectedMealId, setSelectedMealId] = useState("");
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [extraItemsQty, setExtraItemsQty] = useState({});
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [address, setAddress] = useState("");
  const [spCustomAddId, setSpCustomAddId] = useState(null);
  const [mealQty, setMealQty] = useState(1);
  const [addressingId, setAddressingId] = useState(null);
  const [HomeDeliveryStatus, setHomeDeliveryStatus] = useState(false);
  const [customerAddress, setCustomerAddress] = useState(false);
  const [CustomersId, setCustomersId] = useState(null);
  const [CustomersAddress, setCustomersAddress] = useState([]);
  const [mealType, setMealType] = useState({
    lunch: false,
    dinner: false,
  });
  const [deliveryType, setDeliveryType] = useState("pickup");
  const [lunchSlots, setLunchSlots] = useState([]);
  const [dinnerSlots, setDinnerSlots] = useState([]);
  const [IsDinnerslotsAvailable, setIsDinnerslotsAvailable] = useState(false);
  const [IsLunchSlotsAvailable, setIsLunchSlotsAvailable] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedLunch, setSelectedLunch] = useState("");
  const [selectedDinner, setSelectedDinner] = useState("");
  const [allMeals, setAllMeals] = useState([]);
  const [Timeslot, setTimeslot] = useState(null);
  const [PlanType, setPlanType] = useState("");
  const [notes, setNotes] = useState("");
  const [Curr, setCurr] = useState("");
  const [isDateAvailable, setIsDateAvailable] = useState(true);
  const [isLunchAvailable, setIsLunchAvailable] = useState(true);
  const [isDinnerAvailable, setIsDinnerAvailable] = useState(true);
  useEffect(() => {
    dispatch(getAllMealOnOrder())
      .unwrap()
      .then((res) => {
        // console.log("The res of meal is :", res.data)
        const mealsFromApi = res?.data || [];
        setAllMeals(mealsFromApi);

        if (customerData?.meal?.meal_id) {
          const mealData = mealsFromApi.find(
            (m) => m.meal_id === customerData.meal.meal_id,
          );

          setSelectedMeal(mealData || null);
        }
      })
      .catch((err) => {
        console.error("Meal fetch failed", err);
      });
  }, [dispatch, customerData]);

  const mealOptions = allMeals.map((meal) => ({
    label: meal.meal_name, // dropdown me name
    value: meal.meal_id, // actual id
  }));

  useEffect(() => {
    const payload = { order_id: order_id };

    dispatch(getCustomerDataDeliverAnOrder(payload))
      .unwrap()
      .then((res) => {
        // console.log("The api res :", res.data);
        setCurr(res.data?.currency_symbol);
        const data = res.data;
        const customerid = res.data?.customer.customer_id;
        // console.log("The customer id is :", customerid);
        setCustomersId(customerid);
        /* ================= CUSTOMER ================= */
        setCustomerData(data);
        /* ================= DATE ================= */
        setDate(data.order_date);

        /* ================= MEAL QTY ================= */
        setMealQty(data.quantity);

        // Customer address
        setCustomerAddress(data.customer?.addresses?.address_1);

        /* ================= MEAL TIMING ================= */
        setMealType({
          lunch: data.meal_timing === "lunch",
          dinner: data.meal_timing === "dinner",
        });
        setTimeslot(res.data?.time_slot || "");
        setPlanType(data?.meal_plan_type);

        /* ================= DELIVERY TYPE ================= */
        setDeliveryType(data.delivery_type); // "delivery" | "pickup"

        if (data.delivery_type === "delivery") {
          const addr = data.customer?.addresses?.[0];
          // console.log("The address id is :", addr?.address_id);
          setSpCustomAddId(addr?.address_id || null);
          setAddress(addr?.address_1 || "");
        } else {
          setSpCustomAddId(null);
          setAddress("");
        }

        setNotes(res.data?.order_remark);

        /* ================= PRICES ================= */
        setDeliveryCharges(Number(data.delivery_charges));
        setDiscount(data.discount_and_other_charges);
        setTotalAmount(data.total_amount);

        /* ================= ADDRESS ================= */
        setAddress(data.customer?.addresses?.[0]?.address_1 || "");

        /* ================= MEAL ================= */
        setSelectedMealId(data.meal?.meal_id || null);

        /* ================= EXTRA ITEMS ================= */
        const extraQtyMap = {};
        data.extra_items?.forEach((item) => {
          extraQtyMap[item.meal_extra_item_id] = item.quantity;
        });
        setExtraItemsQty(extraQtyMap);

        const getHomeDeliveryStatus = res.data?.is_home_delivery;
        // console.log("The home delivery status is :", getHomeDeliveryStatus);

        setHomeDeliveryStatus(getHomeDeliveryStatus);
      })
      .catch((err) => {
        console.error("API error:", err);
      });
  }, [dispatch, order_id]);

  useEffect(() => {
    if (!CustomersId) return;

    dispatch(getCustomerDetail())
      .unwrap()
      .then((res) => {
        // console.log("the res is : ", res.data);

        const customers = res.data?.customers || [];
        const dinnerSlotsFromApi = res.data?.dinner_time_slot || [];
        const lunchSlotsFromApi = res.data?.lunch_time_slot || [];

        // ✅ Set actual slots
        setDinnerSlots(
          dinnerSlotsFromApi.map((slot) => ({
            label: slot,
            value: slot,
          })),
        );

        setLunchSlots(
          lunchSlotsFromApi.map((slot) => ({
            label: slot,
            value: slot,
          })),
        );

        // 🔥 AUTO SELECT SLOT FOR EDIT PAGE
        if (Timeslot) {
          if (lunchSlotsFromApi.includes(Timeslot)) {
            setSelectedLunch(Timeslot);
          }

          if (dinnerSlotsFromApi.includes(Timeslot)) {
            setSelectedDinner(Timeslot);
          }
        }

        // ✅ Set availability boolean
        setIsDinnerslotsAvailable(dinnerSlotsFromApi.length > 0);
        setIsLunchSlotsAvailable(lunchSlotsFromApi.length > 0);

        // Step 1: Selected customer find karo
        const selectedCustomer = customers.find(
          (detail) => detail.customer_id === CustomersId,
        );
        const getaddress = selectedCustomer.addresses;

        // console.log("The selected customer address is :", getaddress);
        setCustomersAddress(getaddress);

        if (selectedCustomer) {
          // Step 2: Default address find karo
          const defaultAddress = selectedCustomer?.addresses?.find(
            (addr) => addr.is_default === 1,
          );

          const address = defaultAddress?.address_1 || "";
          const addressID = defaultAddress?.address_id || null;

          // console.log("Matched Default Address:", address);

          setAddress(address);
          setAddressingId(addressID);
        }
      })
      .catch(console.error);
  }, [dispatch, CustomersId, Timeslot]);

  useEffect(() => {
    dispatch(getCustomerAddressById({ address_id: addressId }))
      .unwrap()
      .then((res) => {
        setDefaultAdd(res.data.address_1);

        // 🔥 agar delivery active hai, UI auto update
        if (deliveryType === "delivery") {
          setAddress(res.data.address_1);
          setSpCustomAddId(res.data.address_id);
        }
      });
  }, [dispatch, addressId, deliveryType]);

  useEffect(() => {
    if (!selectedMeal) return;

    const mealTotal = mealUnitPrice * mealQty;
    const extraTotal = getExtraItemsTotal();

    const shouldAddDeliveryCharge =
      deliveryType === "delivery" && Number(deliveryCharges) > 0;

    const finalAmount =
      mealTotal +
      extraTotal +
      (shouldAddDeliveryCharge ? Number(deliveryCharges) : 0) +
      Number(discount || 0);

    setOrderAmount(finalAmount);
  }, [
    mealQty,
    extraItemsQty,
    selectedMeal,
    deliveryCharges,
    discount,
    deliveryType, // 🔴 important dependency
  ]);

  const increaseMealQty = () => {
    setMealQty((prev) => prev + 1);
  };

  const decreaseMealQty = () => {
    setMealQty((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const increaseQty = (id) => {
    setExtraItemsQty((prev) => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  const decreaseQty = (id) => {
    setExtraItemsQty((prev) => ({
      ...prev,
      [id]: prev[id] > 1 ? prev[id] - 1 : 0,
    }));
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleMealChange = (e) => {
    const mealId = Number(e.target.value);
    const mealData = allMeals.find((meal) => meal.meal_id === mealId);

    setSelectedMealId(mealId);
    setSelectedMeal(mealData || null);

    // 🔥 FULL RESET
    setMealQty(1);
    setExtraItemsQty({});
    setDiscount(0);
    setDeliveryCharges(0);
    setOrderAmount(0);
    setTotalAmount(0);

    setMealType({
      lunch: false,
      dinner: false,
    });

    setDeliveryType(""); // default pickup
    setSpCustomAddId(null);
    setAddress("");

    // reset extras based on new meal
    const qtyObj = {};
    mealData?.extra_items?.forEach((item) => {
      qtyObj[item.meal_extra_item_id] = 0;
    });
    setExtraItemsQty(qtyObj);
  };

  const mealUnitPrice = selectedMeal?.trial_serving_cost || 0;

  const getExtraItemsTotal = () => {
    if (!selectedMeal?.extra_items) return 0;

    return selectedMeal.extra_items.reduce((sum, item) => {
      const qty = extraItemsQty[item.meal_extra_item_id] || 0;
      return sum + qty * Number(item.amount);
    }, 0);
  };

  useEffect(() => {
    if (!date || !selectedMealId) return;

    const verifyDate = async () => {
      try {
        // console.log("Verify API Running");

        const payload = {
          meal_id: Number(selectedMealId),
          meal_plan_type: "trial",
          order_date: date, // 🔥 FIXED
        };

        // console.log("Verify Payload:", payload);

        const dateRes = await dispatch(verifyOrderStartDate(payload)).unwrap();

        // console.log("Verify Response:", dateRes);

        const lunchAvailable = Boolean(dateRes?.data?.isLunch);
        const dinnerAvailable = Boolean(dateRes?.data?.isDinner);

        setIsDateAvailable(true);
        setIsLunchAvailable(lunchAvailable);
        setIsDinnerAvailable(dinnerAvailable);

        if (!lunchAvailable && !dinnerAvailable) {
          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability:
              "No meal timing available for selected date",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            mealTimingAvailability: "",
          }));
        }
      } catch (err) {
        console.error("Verify API Failed:", err);

        // 🔥 DO NOT disable existing selected timing
        setIsDateAvailable(true);
      }
    };

    verifyDate();
  }, [selectedMealId, date]);

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const validateFields = () => {
    const newErrors = {};

    if (!customerData?.customer?.customer_id) {
      newErrors.customer = "Customer not found";
    }

    if (!selectedMealId) {
      newErrors.selectedMeal = "Please select a meal";
    }

    if (!date) {
      newErrors.date = "Please select order date";
    }

    if (!mealType.lunch && !mealType.dinner) {
      newErrors.mealTiming = "Please select meal timing";
    }

    if (mealType.lunch && IsLunchSlotsAvailable && !selectedLunch) {
      newErrors.timeSlot = "Please select lunch time slot";
    }

    if (mealType.dinner && IsDinnerslotsAvailable && !selectedDinner) {
      newErrors.timeSlot = "Please select dinner time slot";
    }

    if (!deliveryType) {
      newErrors.deliveryType = "Please select delivery type";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOrderUpdate = async () => {
    if (!validateFields()) {
      return;
    }
    let timeSlotes = "";

    if (mealType.lunch) {
      timeSlotes = selectedLunch;
    }

    if (mealType.dinner) {
      timeSlotes = selectedDinner;
    }
    const payload = {
      order_id: order_id,

      service_provider_customer_id: customerData?.customer?.customer_id,

      meal_id: selectedMealId,

      meal_timing: mealType.lunch
        ? "lunch"
        : mealType.dinner
          ? "dinner"
          : "lunch", // fallback safe

      plan_type: customerData?.meal_plan_type || "trial",

      order_date: date,

      quantity: mealQty,

      order_amount: Number(orderAmount),

      delivery_preference: deliveryType === "pickup" ? "pickup" : "delivery",

      ...((deliveryType === "delivery" && spCustomAddId) || addressingId
        ? { sp_customer_address_id: spCustomAddId || addressingId }
        : {}),

      extra_items: Object.entries(extraItemsQty)
        .filter(
          ([id, qty]) =>
            qty > 0 &&
            selectedMeal?.extra_items?.some(
              (e) => e.meal_extra_item_id === Number(id),
            ),
        )
        .map(([id, qty]) => ({
          meal_extra_item_id: Number(id),
          quantity: qty,
        })),

      time_slot: timeSlotes,
      order_remark: notes,
    };

    // console.log("The payload for updating order is :", payload);
    try {
      const res = await dispatch(addOrupdateCustomerOrder(payload)).unwrap();
      // console.log("the res of order update is :", res.data);
      if (!res.success) {
        toast.error(res.message);
        return;
      }

      toast.success(res.message || "Order updated successfully");
      navigate(-1);
    } catch (err) {
      toast.error(err?.message || "Failed to update order");
    }
  };

  return (
    <>
      {isOrderLoading ? (
        <OrderdetailShimmer />
      ) : (
        <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
          <DecorativeSquares />

          {/* Header */}
          <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
            <button
              onClick={handleGoBack}
              className="flex items-center p-2 rounded-full hover:bg-gray-100"
            >
              <FaArrowLeft size={20} />
            </button>

            <h1 className="mx-auto text-2xl font-semibold text-gray-900">
              Edit Order
            </h1>
          </div>
          <div className="px-0 md:px-4 mt-8">
            <div className="mx-auto space-y-4 w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-2 md:p-6 shadow-sm">
              <div>
                <div className="flex items-center gap-4 mb-4">
                  {/* Avatar */}
                  <div className="flex items-center justify-center w-12 h-12 rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                    {getInitials(customerData?.customer?.customer_name)}
                  </div>
                  {/* User Info */}
                  <div className="flex flex-col">
                    <h2 className="text-base font-semibold text-gray-900">
                      {customerData?.customer?.customer_name}
                    </h2>

                    <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                      #{customerData?.order_unique_id}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex justify-center text-center mt-8">
                <span
                  className={`text-sm rounded-full w-auto px-3 py-1 border font-medium
                ${
                  customerData?.status === "pending"
                    ? "bg-[#FFF0D1] text-[#E9A626] border-[#E9A626] animate-pulse"
                    : customerData?.status === "delivered"
                      ? "bg-green-100 text-green-600 border-green-600"
                      : customerData?.status === "cancelled"
                        ? "bg-red-100 text-red-600 border-red-600"
                        : "bg-gray-100 text-gray-600 border-gray-400"
                }
              `}
                >
                  {customerData?.status}
                </span>
              </div>

              <div>
                {customerData?.meal_plan_type === "trial" ? (
                  <Select
                    label={"Select Meal"}
                    required={true}
                    options={mealOptions}
                    value={selectedMealId}
                    onChange={handleMealChange}
                  />
                ) : (
                  <Select
                    required={true}
                    label={"Select Meal"}
                    options={mealOptions}
                    value={selectedMealId}
                    disabled
                    onChange={handleMealChange}
                  />
                )}
                {errors.selectedMeal && (
                  <p className="text-xs text-red-500 mt-1">
                    {errors.selectedMeal}
                  </p>
                )}
              </div>
              {selectedMeal && (
                <div className="mt-4 border border-gray-100 rounded-md p-4">
                  <div className="flex items-center flex-wrap justify-between gap-4">
                    {/* Left */}
                    <div className="flex items-center gap-4">
                      <img
                        src={selectedMeal.meal_cover_image}
                        alt={selectedMeal.meal_name}
                        className="w-12 h-12 rounded-md object-cover"
                      />

                      <div>
                        <h2 className="text-base font-semibold">
                          {selectedMeal.meal_name}
                        </h2>
                        <p className="text-[#FF6943] font-bold">
                          {Curr} {selectedMeal.trial_serving_cost}
                        </p>
                      </div>
                    </div>

                    {/* Right - Quantity */}
                    <div className="flex items-center gap-3">
                      <button
                        onClick={decreaseMealQty}
                        className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                      >
                        −
                      </button>

                      <span className="border h-8 w-8 rounded-md flex items-center justify-center text-sm">
                        {mealQty}
                      </span>

                      <button
                        onClick={increaseMealQty}
                        className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <p className="mt-2 text-sm text-gray-500">
                    {selectedMeal.meal_description}
                  </p>
                </div>
              )}
              <p>Extra items</p>
              {selectedMeal?.extra_items?.map((item) => (
                <div
                  key={item.meal_extra_item_id}
                  className="border border-gray-100 p-4 rounded-md"
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-gray-700">{item.name}</p>
                      <p className="text-[#FF6943] font-bold">${item.amount}</p>
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => decreaseQty(item.meal_extra_item_id)}
                        className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                      >
                        −
                      </button>
                      <span className="border h-8 w-8 rounded-md flex items-center justify-center text-sm">
                        {extraItemsQty[item.meal_extra_item_id] || 0}
                      </span>
                      <button
                        onClick={() => increaseQty(item.meal_extra_item_id)}
                        className="border h-8 w-8 rounded-md bg-[#FF6943] text-white"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <p className="text-sm text-gray-800 text-start mb-2">
                    Plan Type <span className="text-red-500 ml-1">*</span>
                  </p>
                  <div className="border border-gray-200 rounded-xl bg-gray-50 p-3 flex items-center">
                    {PlanType === "trial" ? (
                      <p className="text-sm font-medium text-gray-800">
                        Trial <span className="text-gray-500">(1 Meal)</span>
                      </p>
                    ) : (
                      <p className="text-sm font-medium text-gray-800">
                        {PlanType}
                      </p>
                    )}
                  </div>
                </div>
                <CalendarInput
                  required={true}
                  label="Order date"
                  variant="trial"
                  value={date}
                  onChange={(val) => {
                    setDate(val);
                    setIsDateAvailable(true);
                    setErrors((prev) => ({
                      ...prev,
                      date: "",
                      mealTimingAvailability: "",
                    }));
                  }}
                />
                {errors.date && (
                  <p className="text-xs text-red-500 mt-1">{errors.date}</p>
                )}
              </div>

              <div>
                <p className="text-sm text-gray-800 text-start">
                  Meal Timing <span className="text-red-500 ml-1">*</span>
                </p>

                <div className="flex gap-3 flex-wrap mt-4">
                  {/* Lunch */}
                  <Checkbox
                    variant="pill"
                    label="Lunch"
                    name="lunch"
                    icon={<GoSun />}
                    checked={mealType.lunch}
                    disabled={
                      !isDateAvailable || (!isLunchAvailable && !mealType.lunch) // 🔥 KEY FIX
                    }
                    onChange={() => {
                      setMealType({ lunch: true, dinner: false });
                      setSelectedDinner(null);
                      setErrors((prev) => ({ ...prev, mealTiming: "" }));
                    }}
                    className={`${
                      mealType.lunch
                        ? "bg-[#FF6943] text-white border-[#FF6943]"
                        : ""
                    }`}
                  />

                  {/* Dinner */}
                  <Checkbox
                    variant="pill"
                    label="Dinner"
                    name="dinner"
                    icon={<GoMoon />}
                    checked={mealType.dinner}
                    disabled={
                      !isDateAvailable ||
                      (!isDinnerAvailable && !mealType.dinner) // 🔥 KEY FIX
                    }
                    onChange={() => {
                      setMealType({ lunch: false, dinner: true });
                      setSelectedLunch(null);
                      setErrors((prev) => ({ ...prev, mealTiming: "" }));
                    }}
                    className={`${
                      mealType.dinner
                        ? "bg-[#FF6943] text-white border-[#FF6943]"
                        : ""
                    }`}
                  />
                </div>
                {errors.mealTiming && (
                  <p className="text-xs text-red-500 mt-2">
                    {errors.mealTiming}
                  </p>
                )}
              </div>
              <div className="w-full max-w-md space-y-3 mt-4">
                {/* Lunch Slot */}
                {mealType.lunch && IsLunchSlotsAvailable && (
                  <>
                    <p className="text-sm text-gray-800 text-start">
                      Lunch Time Slot <span className="text-red-500">*</span>
                    </p>

                    <RadioCardGroup
                      options={lunchSlots}
                      name="lunchSlot"
                      selectedValue={selectedLunch}
                      onChange={(value) => {
                        setSelectedLunch(value);
                        setErrors((prev) => ({ ...prev, timeSlot: "" }));
                      }}
                      variant="lunch"
                    />
                  </>
                )}

                {/* Dinner Slot */}
                {mealType.dinner && IsDinnerslotsAvailable && (
                  <>
                    <p className="text-sm text-gray-800 text-start">
                      Dinner Time Slot <span className="text-red-500">*</span>
                    </p>

                    <RadioCardGroup
                      options={dinnerSlots}
                      name="dinnerSlot"
                      selectedValue={selectedDinner}
                      onChange={(value) => {
                        setSelectedDinner(value);
                        setErrors((prev) => ({ ...prev, timeSlot: "" }));
                      }}
                      variant="dinner"
                    />
                  </>
                )}

                {errors.timeSlot && (
                  <p className="text-xs text-red-500 mt-2">{errors.timeSlot}</p>
                )}
              </div>
              <div>
                <p className="text-sm text-gray-800 text-start">
                  Delivery Type <span className="text-red-500 ml-1">*</span>
                </p>
                <div className="flex gap-3 flex-wrap mt-4">
                  <Checkbox
                    variant="radio"
                    label="Home delivery"
                    disabled={!HomeDeliveryStatus}
                    name="delivery"
                    checked={deliveryType === "delivery"}
                    value={customerData.delivery_type}
                    onChange={() => {
                      setDeliveryType("delivery");

                      // 🔥 INSTANT UI FILL
                      if (addressId) {
                        setSpCustomAddId(addressId);
                        setAddress(defaultAdd || "");
                      }
                    }}
                    onDisabledClick={() =>
                      toast.error("Home delivery is not available right now")
                    }
                  />

                  <Checkbox
                    variant="radio"
                    label="Pickup"
                    name="pickup"
                    value={customerData.delivery_type}
                    checked={deliveryType === "pickup"}
                    onChange={() => {
                      setDeliveryType("pickup");
                      setSpCustomAddId(null); // 🔥 VERY IMPORTANT
                      setAddress("");
                    }}
                  />
                </div>
                {deliveryType === "delivery" && (
                  <p className="text-xs text-start text-[#FF6943] mt-2">
                    Delivery Charges : ${customerData?.delivery_charges}
                  </p>
                )}
                {errors.deliveryType && (
                  <p className="text-xs text-red-500 mt-2">
                    {errors.deliveryType}
                  </p>
                )}
              </div>
              <div>
                <div>
                  {deliveryType === "delivery" && (
                    <>
                      {CustomersAddress.length > 0 ? (
                        <InputBase
                          type="textarea"
                          variant="location"
                          rows={2}
                          readOnly
                          onChangeLocation={() =>
                            navigate(
                              `/address/${customerData.customer.customer_id}`,
                              {
                                state: { from: "addOrder" },
                              },
                            )
                          }
                          value={address || customerAddress}
                          onChange={(e) => e.target.value}
                        />
                      ) : (
                        <button
                          onClick={() =>
                            navigate(
                              `/customer/add-customers-address/${customer_id}`,
                            )
                          }
                          className="w-full flex items-center justify-center gap-2 text-sm font-medium text-[#FF6943] border border-dashed rounded-xl py-3 hover:bg-orange-50"
                        >
                          <span className="text-lg">＋</span> Add New Address
                        </button>
                      )}
                    </>
                  )}
                </div>
                <div>
                  <InputBase
                    label={"Order Remark"}
                    type="textarea"
                    placeholder="Enter Order Remark"
                    rows={2}
                    value={notes || ""}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                </div>

                <div>
                  <p>Per order Amount</p>
                  <div className="relative shrink-0 w-full mt-2">
                    <span className="absolute inset-y-0 left-0 flex items-center px-3 text-red-500 bg-red-50 border border-r-0 border-red-200 rounded-l-md text-sm font-medium">
                      {Curr}
                    </span>

                    <input
                      type="text"
                      value={orderAmount}
                      onChange={(e) => e.target.value}
                      disabled
                      className="
                    w-full
                    pl-10 pr-2 py-2
                    text-start text-sm
                    border border-red-200
                    rounded-md
                    outline-none
                    focus:ring-2 focus:ring-red-200
                    "
                    />
                  </div>
                </div>

                <div className="flex justify-end mt-8">
                  <PrimaryBtn
                    btnName="save"
                    clickEvent={handleOrderUpdate}
                    isLoading={isOrderLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Orderedit;
